var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 253.719,
    height: 34,
    viewBox: "0 0 253.719 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_52",
    "data-name": "Grupo 52",
    transform: "translate(686 -2301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_85",
    "data-name": "Caminho 85",
    d: "M110.733.18l12.223,33.712h-7.749L103,.18Z",
    transform: "translate(-624.433 2301.108)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_86",
    "data-name": "Caminho 86",
    d: "M96.139.18l12.223,33.712h-7.813L88.39.18Z",
    transform: "translate(-633.166 2301.108)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_87",
    "data-name": "Caminho 87",
    d: "M81.539.18,93.762,33.892H86.013L73.79.18Z",
    transform: "translate(-641.893 2301.108)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_88",
    "data-name": "Caminho 88",
    d: "M66.881.18,79.1,33.892H71.4L59.18.18Z",
    transform: "translate(-650.626 2301.108)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_89",
    "data-name": "Caminho 89",
    d: "M52.345.18,64.568,33.892H56.8L44.58.18Z",
    transform: "translate(-659.353 2301.108)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_90",
    "data-name": "Caminho 90",
    d: "M37.733.18,49.956,33.892H42.191L30,.18Z",
    transform: "translate(-668.068 2301.108)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_91",
    "data-name": "Caminho 91",
    d: "M22.365,0,34.588,33.712H26.823L14.6,0Z",
    transform: "translate(-677.273 2301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_92",
    "data-name": "Caminho 92",
    d: "M7.765,0,19.988,33.712H12.223L0,0Z",
    transform: "translate(-686 2301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_93",
    "data-name": "Caminho 93",
    d: "M110.733.18l12.223,33.712h-7.749L103,.18Z",
    transform: "translate(-624.433 2301.108)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_94",
    "data-name": "Caminho 94",
    d: "M96.139.18l12.223,33.712h-7.813L88.39.18Z",
    transform: "translate(-633.166 2301.108)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_95",
    "data-name": "Caminho 95",
    d: "M81.539.18,93.762,33.892H86.013L73.79.18Z",
    transform: "translate(-641.893 2301.108)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_96",
    "data-name": "Caminho 96",
    d: "M110.733.18l12.223,33.712h-7.749L103,.18Z",
    transform: "translate(-555.237 2301.108)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_97",
    "data-name": "Caminho 97",
    d: "M96.139.18l12.223,33.712h-7.813L88.39.18Z",
    transform: "translate(-563.97 2301.108)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_98",
    "data-name": "Caminho 98",
    d: "M81.539.18,93.762,33.892H86.013L73.79.18Z",
    transform: "translate(-572.697 2301.108)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashes);
export default __webpack_public_path__ + "static/media/dashes.866cf48dc84fa1bcfd6dfed8931ace01.svg";
export { ForwardRef as ReactComponent };